import { useCallback, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

import { API_EXTENSION_REPORT_EXPORT } from "../../../../../config/Endpoints.js";
import { showError, showSuccess } from "../../../../utils/toast.ts";
import type { ExtensionReportFilters } from "../types.ts";

function exportParams(filters: ExtensionReportFilters): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  if (filters.employeeId != null) params.employeeId = filters.employeeId;
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate) params.toDate = filters.toDate;
  return params;
}

export function useExtensionReportExport() {
  const [exporting, setExporting] = useState(false);
  const token = Cookies.get("accessToken");

  const exportReport = useCallback(async (filters: ExtensionReportFilters) => {
    setExporting(true);
    try {
      const response = await axios.get<Blob>(API_EXTENSION_REPORT_EXPORT, {
        params: exportParams(filters),
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const blob = new Blob([response.data], {
        type: response.data.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Extension_Report.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      showSuccess("Extension report exported successfully.");
    } catch (error) {
      const message = axios.isAxiosError(error) && typeof error.response?.data?.message === "string"
        ? error.response.data.message
        : "Failed to export extension report.";
      showError(message);
    } finally {
      setExporting(false);
    }
  }, [token]);

  return { exportReport, exporting };
}
